<div class="modal" cdkScrollable *rxLet="projectItem.loading$; let projectLoading">
  <header class="modal__header">
    <h2 class="modal__header__title">
      <ng-container *ngIf="isCreateMode && !data.item">{{ 'Create Deviation' | translate }}</ng-container>
      <ng-container *ngIf="!isCreateMode && deviationItem?.data">
        <div class="loader-wrapper">
          <loader [small]="true" [loading]="deviationItem.loading$"></loader>
        </div>
        {{ deviationItem.data.name }}
      </ng-container>
    </h2>

    <button class="modal__header__close" (click)="close()">
      <i class="icon icon-close_ico"></i>
    </button>
  </header>

  <div class="modal__content create-container">
    <loader [loading]="deviationItem.loading$"></loader>
    <loader [loading]="projectItem.loading$"></loader>

    <ng-container
      *ngIf="
        (deviationItem.loaded && !(deviationItem.loading$ | push)) || (isCreateMode && projectItem.loaded && !projectLoading)
      ">
      <deviation-form
        [pageControls]="deviationControls$"
        [deviation]="deviationItem"
        [project]="projectItem"
        [isUserCanDelete]="isUserCanDelete"
        [isUserCanEdit]="isUserCanEdit"
        [isCreateMode]="isCreateMode"
        (back)="deviationCreated($event)"></deviation-form>
    </ng-container>
  </div>

  <div class="modal__actions">
    <div class="btn-group row-flex row-flex--middle mx-0">
      <button class="btn btn__bordered mr-2 uppercase" (click)="close()">
        <span translate>Cancel</span>
      </button>

      <btn-loader
        *rxLet="deviationItem.loadingCrud$; let loadingCrud"
        styleClasses="btn__primary"
        [uppercase]="true"
        [buttonLabel]="'Save' | translate"
        [loading]="loadingCrud.creating || loadingCrud.updating"
        (applyAction)="submit()"
        data-cy="save-btn"></btn-loader>
    </div>
  </div>
</div>
